import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'negocios-list',
  templateUrl: './negocios-list.component.html',
  styleUrls: ['./negocios-list.component.scss']
})
export class NegociosListComponent implements OnInit {

  public loader:any = false;
  public data:any   = null;
  public dataItem = {
    negocio_categoria_id: null
  }
  @Input("changeCategoria") changeCategoria:any = new EventEmitter();

  constructor(
    private api: ApiService
  ){}

  /**
   * 
   * Get data
   * 
   */
  getData(loader=true){

    try{

      this.loader = loader;

      this.api.negocios().list(this.dataItem).subscribe((response:any) => {

        this.loader = false;

        if(response.status == 1){
          this.data = response.data;
        }

      },(response:any) => {

        this.loader = false;

    

      });

    }catch(e:any){

      this.loader = false;

    }

  }
  /**
   * 
   * On Data
   * 
   */
  onData(){

    this.changeCategoria.subscribe((data:any) => {

      this.dataItem.negocio_categoria_id = data;
      this.getData();

    });

  }
  /**
   * 
   * Init
   * 
   */
  ngOnInit(): void {
    this.getData(false);
    this.onData();
  }

}
